(function initPropertyDiscountTimestamp() {
  update()

  setTimeout(update, 1000 * 60)

  async function update() {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {"_last_timestamp": Math.floor(Date.now() / 1000)}
      })
    })
  }
  
})()